// src/components/Header/Header.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';
import './Header.css';

function Header({ theme, onToggleTheme }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isLightTheme = theme === 'light';

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <NavLink to="/" className="site-title">CG.</NavLink>
        
        {/* Desktop Navigation */}
        <nav className="header-navigation">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/projects" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Projects
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/resume" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Resume
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <button
            type="button"
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label={`Switch to ${isLightTheme ? 'dark' : 'light'} mode`}
            aria-pressed={isLightTheme}
            title={`Switch to ${isLightTheme ? 'dark' : 'light'} mode`}
          >
            {isLightTheme ? <FaMoon aria-hidden="true" /> : <FaSun aria-hidden="true" />}
          </button>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`mobile-navigation ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul className="mobile-nav-list">
            <li className="mobile-nav-item">
              <NavLink to="/" className={({ isActive }) => isActive ? "mobile-nav-link active" : "mobile-nav-link"} onClick={closeMobileMenu}>
                Home
              </NavLink>
            </li>
            <li className="mobile-nav-item">
              <NavLink to="/about" className={({ isActive }) => isActive ? "mobile-nav-link active" : "mobile-nav-link"} onClick={closeMobileMenu}>
                About
              </NavLink>
            </li>
            <li className="mobile-nav-item">
              <NavLink to="/projects" className={({ isActive }) => isActive ? "mobile-nav-link active" : "mobile-nav-link"} onClick={closeMobileMenu}>
                Projects
              </NavLink>
            </li>
            <li className="mobile-nav-item">
              <NavLink to="/resume" className={({ isActive }) => isActive ? "mobile-nav-link active" : "mobile-nav-link"} onClick={closeMobileMenu}>
                Resume
              </NavLink>
            </li>
            <li className="mobile-nav-item">
              <NavLink to="/contact" className={({ isActive }) => isActive ? "mobile-nav-link active" : "mobile-nav-link"} onClick={closeMobileMenu}>
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
